export default {
    smsTemplates: [],
    emailTemplates:[]

}